import { render, staticRenderFns } from "./newsletterIS.vue?vue&type=template&id=e65cc6d2"
import script from "./newsletterIS.vue?vue&type=script&lang=js"
export * from "./newsletterIS.vue?vue&type=script&lang=js"
import style0 from "./newsletterIS.vue?vue&type=style&index=0&id=e65cc6d2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports